import { render, staticRenderFns } from "./TagPicker.vue?vue&type=template&id=0e3e15d1"
import script from "./TagPicker.vue?vue&type=script&lang=js"
export * from "./TagPicker.vue?vue&type=script&lang=js"
import style0 from "./TagPicker.vue?vue&type=style&index=0&id=0e3e15d1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports